import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'

// pinia
import { createPinia } from 'pinia'
const pinia = createPinia()
Vue.use(pinia)

// axios
import axios from 'axios'
Vue.prototype.$http = axios

// global css
import('./assets/style/global.scss')

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
